var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDairy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6593 3.64273C19.6232 3.5927 20.3913 2.80235 20.3913 1.82607C20.3913 0.817523 19.5738 0 18.5652 0H9.43481C8.42627 0 7.60869 0.817523 7.60869 1.82607C7.60869 2.80235 8.37683 3.5927 9.34075 3.64268C8.77069 8.79813 6.69568 9.13773 6.69568 14.3234V25.2609C6.69568 26.7713 7.9244 28 9.43481 28H18.5653C20.0757 28 21.3044 26.7713 21.3044 25.2609V14.3234C21.3044 9.12904 19.2307 8.81098 18.6593 3.64273ZM13.4038 11.2879C12.1391 10.4447 10.6391 10.1266 9.21535 10.3027C9.38073 9.8338 9.57284 9.37453 9.79504 8.93009C10.5378 7.44362 10.9997 5.42052 11.1771 3.65214H16.823C17.0003 5.42052 17.4622 7.44362 18.205 8.93009C18.5145 9.54898 18.7693 10.1955 18.9679 10.8589C18.2986 11.191 16.1003 13.0856 13.4038 11.2879Z",
    fill: "#6DA3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDairy);
export default __webpack_public_path__ + "static/media/dairy.b1159d36fc50310ca1d0df94df1e47c4.svg";
export { ForwardRef as ReactComponent };